import store from '@/store';

export default {


  isLogged(to, from, next) {
    if(store.getters['user/isLogged']) {
      next();
    } else {
      next('/auth/login');
    }
  },


  isUnlogged(to, from, next) {
    if(!store.getters['user/isLogged']) {
      next();
    } else {
      next('/dashboard');
    }
  },


  hasPlan(to, from, next) {
    if(store.getters['user/hasPlan']) {
      next();
    } else {
      // next('/dashboard/plans'); // TODO: ЭТО ДЛЯ ДЕМКИ
      next();
    }
  },


  validSubs(to, from, next) {
    if(store.getters['user/hasPlan'] && !store.getters['user/validSubs']) {
      next('/expire');
    } else {
      next();
    }
  },


  isNotSuperImpact(to, from, next) {
    if(store.getters['user/plan'] != 1) {
      next();
    }
  },
};
